import { TBookingContextDef } from '@providers/booking/types'
import { isEmpty } from 'components-ui/src/shared/common'
import { isServiceTypeInStayPlatformEnabled } from 'components-ui/src/shared/location'
import { AvailabilityGroupClientDto } from 'service-api/src/types/api'

export const hasGroomingServiceType = (bookingCtx: TBookingContextDef) => {
  const grooming = bookingCtx.state.data.serviceTypes?.find((st) => st.serviceType?.name === 'grooming')
  if (!grooming) {
    return false
  }
  return isServiceTypeInStayPlatformEnabled(bookingCtx.state.data.serviceType, grooming.id)
}

export const hasGroomsSelected = (bookingCtx: TBookingContextDef) => {
  const groups = bookingCtx.state.cart.groups
  return groups.some((group) => group.grooms && group.grooms.length > 0)
}

export const getServiceTypeFromCtx = (bookingCtx: TBookingContextDef, locationServiceTypeName: string) =>
  bookingCtx.state.data.serviceTypes?.find((st) => st.serviceType?.name === locationServiceTypeName)

export const areGroomsAllSet = (bookingCtx: TBookingContextDef) => {
  const standaloneGroom = bookingCtx.state.serviceTypeName === 'grooming'
  const groups = bookingCtx.state.cart.groups

  if (standaloneGroom) {
    if (groups.every((group) => typeof group.grooms === 'undefined' || group.grooms.length === 0)) {
      return false
    }
    // when standalone groom, all groups with a groom selected must be on allSet state
    return groups.every((group) => group.grooms.every((g) => g.offers.length > 0 && g.isDone))
  }

  // if inStay groom, and no groom selected, is ok to continue
  if (groups.every((group) => group.grooms.every((g) => g.offers.length === 0))) {
    return true
  }

  // if some pet has a groom selected, must be on allSet state
  return groups.every((group) => group.grooms.every((g) => (g.offers.length > 0 ? g.isDone : true)))
}

export const isAvailableForWaitlist = (availability: AvailabilityGroupClientDto): boolean => {
  const avail = availability.availabilities?.[0]
  if (!avail) {
    return true
  }

  return !isEmpty(avail.unavailableType) && avail.unavailableType === 'INVENTORY'
}
